// Example presets for AI Designer
export interface AIDesignerExamplePreset {
    id: number;
    name: string;
    clothPreview: string;
    prompt: string;
    results: string[];
}

export const aiDesignerExamplePresets: AIDesignerExamplePreset[] = [
    {
        id: 1,
        name: 'Yellow Kurti',
        clothPreview: "https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Finspiration-photoshoot%2Fai-design-examples%2Fexample-1%2Fclothes_1.jpeg?alt=media&token=2181506a-5317-4729-b559-5ee37541ba9d",
        prompt: 'Modern stylish top design with elegant patterns',
        results: [
            "https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Finspiration-photoshoot%2Fai-design-examples%2Fexample-1%2Fai_design_1.jpeg?alt=media&token=5d1102eb-3359-4335-9999-56a945e4e030"
        ]
    },
    {
        id: 2,
        name: 'Designer Dress',
        clothPreview: "https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Finspiration-photoshoot%2Fai-design-examples%2Fexample-1%2Fclothes_2.jpg?alt=media&token=c97bad79-ee15-4b8c-83f5-5760837456c7",
        prompt: "Professional designer dress with modern aesthetic",
        results: [
            "https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Finspiration-photoshoot%2Fai-design-examples%2Fexample-1%2Fai_design_2.jpg?alt=media&token=f4465e97-1263-4e76-a12b-5006f8f09c1b"
        ]
    },
    {
        id: 3,
        name: 'Indian Kurti',
        clothPreview: 'https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Finspiration-photoshoot%2Fai-design-examples%2Fexample-1%2Fclothes_4.jpg?alt=media&token=57c00bc2-d801-4e6d-95ad-22c0bd9c6a46',
        prompt: 'Beautiful indian kurti with floral patterns',
        results: [
            'https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Finspiration-photoshoot%2Fai-design-examples%2Fexample-1%2Fai_design_4.jpg?alt=media&token=4fc0ec17-636a-4076-aa98-a7d9c791252c'
        ]
    }
];

export type ExamplePreset = AIDesignerExamplePreset;

